var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.91699L15 1.66699L13.75 2.91699L12.5 1.66699L11.25 2.91699L10 1.66699L8.75 2.91699L7.5 1.66699L6.25 2.91699L5 1.66699V13.3337H2.5V15.8337C2.5 17.217 3.61667 18.3337 5 18.3337H15C16.3833 18.3337 17.5 17.217 17.5 15.8337V1.66699L16.25 2.91699ZM12.5 16.667H5C4.54167 16.667 4.16667 16.292 4.16667 15.8337V15.0003H12.5V16.667ZM15.8333 15.8337C15.8333 16.292 15.4583 16.667 15 16.667C14.5417 16.667 14.1667 16.292 14.1667 15.8337V13.3337H6.66667V4.16699H15.8333V15.8337Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83366H7.5V7.50033H12.5V5.83366Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.83366H13.3333V7.50033H15V5.83366Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.33366H7.5V10.0003H12.5V8.33366Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.33366H13.3333V10.0003H15V8.33366Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptLong);
export default __webpack_public_path__ + "static/media/receipt_long.a0010517f1842166c6011b757fabe5cc.svg";
export { ForwardRef as ReactComponent };